<div class="support-details-view-container" *ngIf="supportObject" fxLayout="column" fxLayoutGap="15px" >
  <div class="id-info">
    <mat-form-field appearance="fill" color="accent">
      <mat-label>ID</mat-label>
      <input matInput placeholder="ID" [disabled]="true" [value]="supportObject.recordId?.toString()">
    </mat-form-field>
  </div>

  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + supportObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="supportObject.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).support.write || supportObject.status?.key === 'closed'" (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>

  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card >
        <div fxLayout="row">
          <h3>Dane</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <app-detail header="Osoba zgłaszająca" [value]="supportObject.clientType.name"></app-detail>
          </div>
          <div fxFlex="50">
            <app-detail header="Forma kontaktu" [value]="supportObject.typeOfReport.name"></app-detail>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column" >
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Osoba zgłaszająca</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">

          <div fxFlex="50" >
            <app-detail header="Partner" [value]="supportObject.partner?.shortName"
                        [link]="supportObject.partner ? ['/partnerzy/szczegoly', supportObject.partner.uuid] : undefined"></app-detail>
          </div>

          <div fxFlex="50" >
            <app-detail header="OFWCA" [value]="supportObject.ofwca?.fullName"
                        [link]="supportObject.ofwca ? ['/ofwca/szczegoly', supportObject.ofwca.uuid] : undefined"></app-detail>
          </div>

        </div>
      </mat-card>
    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Rodzaj aktywności</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div  fxFlex = "100">
            <app-detail header="Rodzaj aktywności" [value]="supportObject.typeOfActivity.name"></app-detail>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column" >
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>TU</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <table fxFlex="60"   >
            <tr *ngFor="let headers of supportObject.insuranceCompanys">

              <td> {{headers}}</td>

            </tr>
          </table>
        </div>
      </mat-card>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column"  *ngIf="supportObject.propertyRisk.length > 0 || supportObject.lifeRisk.length > 0">
    <div fxFlex="100" *ngIf="supportObject.propertyRisk.length > 0" >
      <mat-card fxFlex="100">
        <div fxLayout="row">
          <h3>Ryzyka majątkowe</h3>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" >
          <div fxFlex="100">
            <app-detail header="">
              <mat-chip-list>
                <ng-container *ngFor="let risk of supportObject.propertyRisk; let last = last">
                  <mat-chip color="accent" selected>{{risk.name}}</mat-chip>
                </ng-container>
              </mat-chip-list>
            </app-detail>
          </div>
        </div>

      </mat-card>
    </div>
    <div fxFlex="100" *ngIf="supportObject.lifeRisk.length > 0">
      <mat-card fxFlex="100">
        <div fxLayout="row">
          <h3>Ryzyka życiowe</h3>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" >
          <div fxFlex="100">
            <app-detail header="">
              <mat-chip-list>
                <ng-container *ngFor="let risk of supportObject.lifeRisk; let last = last">
                  <mat-chip color="accent" selected>{{risk.name}}</mat-chip>
                </ng-container>
              </mat-chip-list>
            </app-detail>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <app-detail header="Dane klienta" [value]="supportObject.customerData"></app-detail>
          </div>
        </div>


        <div fxLayout="row" fxLayoutGap="15px" >
          <div fxFlex="100">
            <app-detail-bool header="Czy zawarta polisa" [value]="supportObject.concludedPolicy"></app-detail-bool>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <app-detail header="Numer polisy" [value]="supportObject.policyNumber"></app-detail>
          </div>
        </div>

      </mat-card>
    </div>
  </div>


  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Notatka do rozmowy</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <app-detail header="" [value]="supportObject.note"></app-detail>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
